import React from "react";
import "./ContestDetails.css";
import {isMobile} from "react-device-detect";
import {arrow_line} from "./images";


const ContestDetails = (props) => {


    return (
        <div style={{zIndex: 10, display: "flex", justifyContent: "center", flexDirection: 'column'}}>
            <p className={"main-text"}>Contest Details</p>
            <div className={"contest-gradient"}>
                <div style={{display: "flex", flexDirection: isMobile ? "column": "row", gap: 1.5}}>
                    <div style={isMobile ? {borderTopRightRadius: 15, borderTopLeftRadius: 15} : {flex: 2, borderTopLeftRadius: 15}} className={"contest-normal"}>
                        <p className={'contest-title-text'}>Duration</p>
                        <p className={'contest-text'}>The contest will start on May 1, 2024, and end on May 15, 2024.</p>
                    </div>
                    <div style={isMobile ? {} : {flex: 3, borderTopRightRadius: 15}}  className={"contest-normal"}>
                        <p className={'contest-title-text'}>Objective</p>
                        <p className={'contest-text'}>Participants from both TradeX and PRDT Finance will trade on each other's platforms to compete for a spot in the top 50 leaderboard.</p>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: isMobile ? "column": "row", gap: 1.5}}>
                    <div style={isMobile ? {} : {flex: 2}}  className={"contest-normal"}>
                        <p className={'contest-title-text'}>Leaderboard Announcement</p>
                        <p className={'contest-text'}>After the week of trading concludes, the top 50 traders across both platforms will be announced.</p>
                    </div>
                    <div style={isMobile ? {} : {flex: 3}}  className={"contest-normal"}>
                        <p className={'contest-title-text'}>Reward Pool</p>
                        <p className={'contest-text'}>Top 50 traders will share upto 1000 USDT rewards pool.</p>
                    </div>
                </div>

                <div style={{borderBottomRightRadius: 15, borderBottomLeftRadius: 15}} className={"contest-normal"}>
                    <p className={'contest-title-text'}>TradeX Signup Bonus</p>
                    <p className={'contest-text'}>As an exclusive offer, TradeX is providing <span style={{color: "rgba(10, 87, 255, 1)"}}>2500 token points</span> to new users upon signup, which they can use to trade on the platform during the contest period.</p>
                </div>

            </div>
            <div style={{display: "flex", justifyContent: "center"}}>
                <img src={arrow_line()} height={70} style={{margin: 30, zIndex: 10}}></img>
            </div>
        </div>
    );
};



export default (ContestDetails);
